module.exports = __webpack_public_path__ + "static/media/Operator report.89677a93.png";